var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarificationSucessful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.69 80.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3aae76;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.35,80.69C18.1,80.69,0,62.59,0,40.35S18.1,0,40.35,0s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35Zm0-77.69C19.75,3,3,19.75,3,40.35s16.75,37.35,37.35,37.35,37.35-16.75,37.35-37.35S60.94,3,40.35,3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.56 53.23 26.51 42.46 28.36 40.56 37.15 49.14 52 27.46 54.18 28.95 37.56 53.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarificationSucessful);
export default __webpack_public_path__ + "static/media/varification_sucessful.52a20d891aa074eaf991fa7a4641e3a5.svg";
export { ForwardRef as ReactComponent };